/**
 * @module builder
 */
import type { AreaSubstrate, OptionsDocument, QuoteDocument } from 'paintscout'

import cloneDeep from 'lodash/cloneDeep'
import { getEntityType, calculateQuote, getItemSection } from '../../util'
import type { QuoteItemSection } from '../..'
import { removeOrderItem } from './remove-order-item'

export function removeItem(args: {
  quote: QuoteDocument
  options: OptionsDocument
  key: string
  section?: QuoteItemSection
}): QuoteDocument {
  const { quote, options, key, section } = args

  const entityType = getEntityType({ quote, key })
  if (entityType === null) {
    return {
      ...quote
    }
  }

  // Only remvove order key if we are removing full item,
  // If we end up removing hte full archived items, we will remove it later
  let quoteWithoutOrder = section === 'archived' ? quote : removeOrderItem({ quote, key })

  // delete item without mutating original quote
  /* eslint-disable-next-line */
  let { [key]: removedArea, ...updatedAreas } = quote.areas
  /* eslint-disable-next-line */
  const { [key]: removedLineItem, ...updatedLineItems } = quote.lineItems

  const movedAreaSubstrates: any = {}
  if (entityType === 'areas' && section === 'archived') {
    // If it is an area, and we are in archived deleting it
    // We only want to remove the substrates in archived section of area,
    // and not the entire area, unless all substrates are in archived
    const updatedArea = cloneDeep(removedArea)
    const newOrder = []
    const newSubstrates = {}

    Object.keys(removedArea.substrates).forEach((rateSection: string) => {
      movedAreaSubstrates[rateSection] = []
      removedArea.substrates[rateSection].forEach((substrate: AreaSubstrate) => {
        const areaSubstrateSection = getItemSection(substrate)

        if (areaSubstrateSection !== section) {
          newOrder.push({ key: substrate.key })
          newSubstrates[rateSection] = [...(newSubstrates[rateSection] ?? []), substrate]
        }
      })
    })
    // If we kept any items, re-add the area with the new substrates
    if (newOrder.length) {
      // Re-add the area with removed substrates to the updatedAreas
      updatedAreas = {
        ...updatedAreas,
        [key]: {
          ...updatedArea,
          substrateOrder: newOrder,
          substrates: newSubstrates
        }
      }
    } else {
      // Skipped this earlier, if we keep noting we want to remove it
      quoteWithoutOrder = removeOrderItem({ quote: quoteWithoutOrder, key })
    }
  }

  const updatedQuote = {
    ...quoteWithoutOrder,
    areas: updatedAreas,
    lineItems: updatedLineItems
  }

  return calculateQuote({ quote: updatedQuote, options })
}
